import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";
import { redblueActivityCreateFormMessages } from "./forms-activity-create";
import { redblueSchemeFormMessages } from "./forms-scheme";
import { mergeLocaleCatalogSlices } from "./merge-message-tree";

export const redblueFormMessages: Record<AppLocale, MessageTree> = mergeLocaleCatalogSlices([
  redblueSchemeFormMessages,
  redblueActivityCreateFormMessages,
]);
